import {
  IPrivateChat,
  IGroupChat,
  ITextMessage,
  IDataMessage,
} from 'Shared/Types/chat';

const privateNames = [
  'John Doe',
  'Jane Doe',
  'Alice Smith',
  'Bob Johnson',
  'Emily Davis',
  'Michael Wilson',
  'Sarah Brown',
  'Daniel Martinez',
];
const privateMessages = [
  'Hey there! How have you been?',
  'Don’t forget our meeting tomorrow.',
  'Can you send me the report?',
  'It was great seeing you last week!',
  'Just checking in. Everything okay?',
  'Did you hear about the new project?',
  'Remember to update your tasks.',
  'Looking forward to our next catch-up!',
];
const groupNames = [
  'North Dispatch Unit',
  'East Coast Drivers',
  'HR Compliance Team',
  'Central Dispatch Coordinators',
  'West Coast Drivers',
  'HR Recruitment Team',
  'Southern Dispatch Team',
  'Midwest Drivers',
];
const groupMessages = [
  'Don’t forget the team meeting.',
  'Great job on the project!',
  'Who’s available for a call?',
  'Let’s schedule the next sprint planning.',
  'We need to finalize the presentation.',
  'Any updates on the client feedback?',
  'Reminder: deadline approaching!',
  'Let’s brainstorm some new ideas.',
];
const roles = ['dispatcher', 'accountant', 'HR', 'driver'];

const getRandomTimestamp = () => {
  const start = new Date(2023, 0, 1);
  const end = new Date();
  const timestamp = new Date(
    start.getTime() + Math.random() * (end.getTime() - start.getTime()),
  );

  return timestamp.toISOString();
};

const spliceRandomElement = (array: string[]) => {
  const index = Math.floor(Math.random() * array.length);
  const chosenName = array[index];
  array.splice(index, 1);

  return chosenName;
};

const generateUSPhoneNumber = (): string => {
  const getRandomDigits = (count: number): string => {
    return Array.from({ length: count }, () =>
      Math.floor(Math.random() * 10),
    ).join('');
  };

  const part1 = getRandomDigits(3);
  const part2 = getRandomDigits(3);
  const part3 = getRandomDigits(4);

  return `+1-${part1}-${part2}-${part3}`;
};

const getRandomNumber = (start: number, end: number): number => {
  if (start > end) {
    [start, end] = [end, start];
  }

  return Math.floor(Math.random() * (end - start + 1)) + start;
};

const messages: (ITextMessage | IDataMessage)[] = [
  {
    id: 1,
    user_name: 'Admin Admin',
    user_role: 'admin',
    timestamp: new Date('2024-05-01T08:00:00Z').toISOString(),
    link: 'www.some-link.com/directory/file_name.png',
    file_size: 1887436,
  },
  {
    id: 2,
    user_name: privateNames[getRandomNumber(0, privateNames.length - 1)],
    user_role: roles[getRandomNumber(0, roles.length - 1)],
    timestamp: new Date('2024-05-01T08:20:00Z').toISOString(),
    link: 'www.some-link.com/directory/file_name.png',
    file_size: 1887436,
  },
  {
    id: 3,
    user_name: 'Admin Admin',
    user_role: 'admin',
    timestamp: new Date('2024-05-01T09:00:00Z').toISOString(),
    text: 'Please confirm pickup at Warehouse A at 10 AM.',
  },
  {
    id: 4,
    user_name: privateNames[getRandomNumber(0, privateNames.length - 1)],
    user_role: roles[getRandomNumber(0, roles.length - 1)],
    timestamp: new Date('2024-05-01T10:00:00Z').toISOString(),
    text: 'Pickup confirmed. On the way to Warehouse A.',
  },
  {
    id: 5,
    user_name: privateNames[getRandomNumber(0, privateNames.length - 1)],
    user_role: roles[getRandomNumber(0, roles.length - 1)],
    timestamp: new Date('2024-05-01T11:00:00Z').toISOString(),
    text: 'Goods picked up. Heading to Delivery Point B.',
  },
  {
    id: 6,
    user_name: privateNames[getRandomNumber(0, privateNames.length - 1)],
    user_role: roles[getRandomNumber(0, roles.length - 1)],
    timestamp: new Date('2024-05-02T09:00:00Z').toISOString(),
    text: 'Reminder: Delivery at Point B scheduled for 11 AM today.',
  },
  {
    id: 7,
    user_name: 'Admin Admin',
    user_role: 'admin',
    timestamp: new Date('2024-05-02T10:00:00Z').toISOString(),
    text: 'Traffic update: Possible delay due to road construction.',
  },
  {
    id: 8,
    user_name: privateNames[getRandomNumber(0, privateNames.length - 1)],
    user_role: roles[getRandomNumber(0, roles.length - 1)],
    timestamp: new Date('2024-05-02T11:00:00Z').toISOString(),
    text: 'Arrived at Delivery Point B. Unloading cargo now.',
  },
  {
    id: 9,
    user_name: 'Admin Admin',
    user_role: 'admin',
    timestamp: new Date('2024-05-03T09:00:00Z').toISOString(),
    text: 'Next assignment: Pickup at Warehouse C at 12 PM.',
  },
  {
    id: 10,
    user_name: privateNames[getRandomNumber(0, privateNames.length - 1)],
    user_role: roles[getRandomNumber(0, roles.length - 1)],
    timestamp: new Date('2024-05-03T10:00:00Z').toISOString(),
    text: 'Route update: Use Highway 45 for faster travel to Warehouse C.',
  },
  {
    id: 11,
    user_name: 'Admin Admin',
    user_role: 'admin',
    timestamp: new Date('2024-05-03T11:00:00Z').toISOString(),
    text: 'ETA at Warehouse C is 12:30 PM due to minor delay.',
  },
  {
    id: 12,
    user_name: privateNames[getRandomNumber(0, privateNames.length - 1)],
    user_role: roles[getRandomNumber(0, roles.length - 1)],
    timestamp: new Date('2024-05-03T12:00:00Z').toISOString(),
    text: 'Goods picked up from Warehouse C. Heading to Delivery Point D.',
  },
];

const privateChats: IPrivateChat[] = new Array(8).fill(null).map((_, index) => {
  const name = spliceRandomElement(privateNames);

  return {
    id: index + 1,
    name,
    last_message: spliceRandomElement(privateMessages),
    last_timestamp: getRandomTimestamp(),
    user_id: index + 1,
    user_phone: generateUSPhoneNumber(),
    user_role: roles[getRandomNumber(0, roles.length - 1)],
  };
});
privateChats[0].last_timestamp = null;
privateChats[1].last_timestamp = null;

let groupChats: IGroupChat[] = new Array(8).fill(null).map((_, index) => {
  return {
    id: index + 1,
    name: spliceRandomElement(groupNames),
    last_message: spliceRandomElement(groupMessages),
    last_timestamp: getRandomTimestamp(),
    avatar: null,
    users_count: getRandomNumber(2, 9),
  };
});
groupChats[0].last_timestamp = null;
groupChats[1].last_timestamp = null;

export { privateChats, groupChats, messages };
